import {times} from 'lodash';
import styled from 'styled-components';

import {Skeleton} from '~/shared/components/Loaders';

import {
  DetailsWrapper,
  DropdownList,
  LogoAndDetailsWrap,
  LogoWrap,
  OverlayGradientBackground,
  ReorderItemWrapper,
  ContentWrapper,
  DetailsAndOrderButtonWrapper,
} from '../../dropdown.styled';

const CommonSkelteon = styled(Skeleton)`
  height: 16px;
  margin-bottom: 4px;
`;

const SkeletonLogo = styled(Skeleton)`
  width: 56px;
  height: 56px;
  border-radius: 50%;
`;

const SkeletonRestaurantName = styled(CommonSkelteon)`
  width: 150px;
`;

const SkeletonOrderDate = styled(CommonSkelteon)`
  width: 80px;
  margin-bottom: 8px;
`;

const SkeletonPreviewButton = styled(CommonSkelteon)`
  width: 72px;
  margin: 0;
`;

const SkeletonOrderButton = styled(SkeletonOrderDate)`
  height: 32px;
  margin-bottom: 0;
`;

const ReorderLoaderComponent = ({isPage}) => {
  return (
    <DropdownList isPage={isPage}>
      {times(5, num => (
        <ReorderItemWrapper isPage={isPage} key={num}>
          <LogoAndDetailsWrap>
            <LogoWrap>
              <SkeletonLogo />
            </LogoWrap>
            <ContentWrapper>
              <SkeletonRestaurantName />
              <DetailsAndOrderButtonWrapper>
                <DetailsWrapper>
                  <SkeletonOrderDate />
                  <SkeletonPreviewButton />
                </DetailsWrapper>
                <SkeletonOrderButton />
              </DetailsAndOrderButtonWrapper>
            </ContentWrapper>
          </LogoAndDetailsWrap>
        </ReorderItemWrapper>
      ))}
      <OverlayGradientBackground bottom show />
    </DropdownList>
  );
};

export default ReorderLoaderComponent;
